import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import MiscGrnRejectionModal from "../components/miscGrnRejectionModal";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const AddMiscGrnReject = () => {
  useAuthRedirect();
  const { fld_purnumber } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]); 
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [oldGrn, setOldGrn] = useState(null);  
  const [supplierNo, setSupplierNo] = useState(null); 
  const [fetchPo, setFetchPo] = useState(null);  
const [freight, setFreight] = useState(""); 
const [poNumber, setPoNo] = useState(""); 
const [subDetails, setSubDetails] = useState({})
const [formData, setFormData] = useState({})
const navigate = useNavigate();

useEffect(() => {
  const fetchPoNo = async () => {
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/miscgrnReject_no`);
      if (response.data.PoNo) {
        const NewPo = parseInt(response.data.PoNo, 10) || 0;
        setPoNo(NewPo.toString());
        setFormData(prevState => ({ ...prevState, PoNumber: NewPo.toString() }));
      }
    } catch (error) {
      console.error("Error fetching indent number:", error);
    }
  };
  fetchPoNo();
}, []);

const handleSelectItem = async (supplier) => {
  try {
    setOldGrn(supplier.headernumber); 
    setSupplierNo(supplier.grnheader_suppliercode)
    setFetchPo(supplier.grnDetail_poNumber)
    const response = await axios.get("https://rfs2.infraconsoft.net.in/api/miscgetRejectGrnItems", {
      params: {
        oldGrnNo: supplier.headernumber,
        branch: branch,
      },
    });

    if (response.data.length > 0) {
      setSelectedItems(response.data);
    }
  } catch (error) {
    console.error("Error fetching supplier items:", error);
  }
};


useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${supplierNo}`);
            const items = response.data.supDetails;
            console.log(response.data.supDetails);
            
            const storeReqHeader1 = {
                supplierMaster_code: items[0].supplierMaster_code || "N/A",
                supplierMaster_name: items[0].supplierMaster_name || "N/A",
                supplierMaster_addressline1 : items[0].supplierMaster_addressline1 || "N/A",
                supplierMaster_addressline2 : items[0].supplierMaster_addressline2 || "N/A",
                supplierMaster_city : items[0].supplierMaster_city || "N/A",
                supplierMaster_pincode : items[0].supplierMaster_pincode || "N/A",
                
            };
            setSubDetails(storeReqHeader1);
            // setData(response.data.supDetails);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchSupplierDetails();
  }, [supplierNo]); 


  // Calculate totals
  const totals = selectedItems.reduce(
    (acc, item) => {
      const itemValue = item.grnDetail_excessShortageQuantity * item.grnDetail_price;
      const discountValue = itemValue * (item.grnDetail_discountPercentage / 100);
      const pfValue = itemValue * (item.grnDetail_pfPercentage / 100);
      const taxValue = itemValue * (item.grnDetail_CSTtax / 100);
      const totalValue = itemValue + taxValue + pfValue - discountValue;

      acc.totalItemValue += itemValue;
      acc.totalDiscValue += discountValue;
      acc.totalTaxValue += taxValue;
      acc.totalPfValue += pfValue;
      acc.grandTotalValue += totalValue ;

      return acc;
    },
    {
      totalItemValue: 0,
      totalDiscValue: 0,
      totalTaxValue: 0,
      totalPfValue: 0,
      grandTotalValue: 0,
    }
  );

  const freightAmount = isNaN(parseFloat(freight)) ? 0.00 : parseFloat(freight);
  const finalTotal = totals.grandTotalValue + freightAmount;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  // ✅ 1. Check items
  if (selectedItems.length === 0) {
    Swal.fire("Error", "Please add at least one item", "error");
    return;
  }

  // ✅ 2. Validate dcNo
  if (!formData.dcNo || isNaN(formData.dcNo) || Number(formData.dcNo) <= 0) {
    Swal.fire("Validation Error", "DC No must be a valid number greater than 0.", "warning");
    return;
  }

  // ✅ 3. Validate dcDate
  if (!formData.dcDate || isNaN(Date.parse(formData.dcDate))) {
    Swal.fire("Validation Error", "DC Date must be a valid date.", "warning");
    return;
  } 

  // ✅ 4. Validate invoiceNo
  if (!formData.invoiceNo || isNaN(formData.invoiceNo) || Number(formData.invoiceNo) <= 0) {
    Swal.fire("Validation Error", "Invoice No must be a valid number greater than 0.", "warning");
    return;
  }

  // ✅ 5. Validate invoiceDate
  if (!formData.invoiceDate || isNaN(Date.parse(formData.invoiceDate))) {
    Swal.fire("Validation Error", "Invoice Date must be a valid date.", "warning");
    return;
  } 
  // ✅ 6. Build payload after validations
  const payload = {
    branch: branch,
    newGrn: formData.PoNumber,
    oldGrn: oldGrn,
    poNumber: fetchPo,
    user: user,
    scode: subDetails.supplierMaster_code,
    dcNo: formData.dcNo,
    dcDate: formData.dcDate,
    invoiceNo: formData.invoiceNo,
    invoiceDate: formData.invoiceDate,
    paymentTerms: formData.paymentTerms,
    transport: formData.transport,
    frightAmt: freight,
    delMethod: formData.delMethod,
    delPlace: formData.delPlace,
    grandTot: finalTotal.toFixed(2),
    remarks: formData.remarks,
    priceBasis: formData.priceBasis,
    subValue: totals.totalItemValue.toFixed(2),
    pfValue: totals.totalPfValue.toFixed(2),
    discValue: totals.totalDiscValue.toFixed(2),
    cst: totals.totalTaxValue.toFixed(2),
    totValue: totals.grandTotalValue.toFixed(2),

    items: selectedItems.map((item) => {
      const itemValue = item.grnDetail_excessShortageQuantity * item.grnDetail_price;
      const discountValue = itemValue * (item.grnDetail_discountPercentage / 100);
      const pfValue = itemValue * (item.grnDetail_pfPercentage / 100);
      const taxValue = itemValue * (item.grnDetail_CSTtax / 100);
      const totalValue = itemValue + taxValue + pfValue - discountValue;

      return {
        itemCode: item.grnDetail_itemcode,
        itemName: item.itemmaster_name,
        itemUom: item.itemMaster_purchaseUom,
        totalQty: item.grnDetail_poPendingQuantity,
        price: item.grnDetail_price,
        accQty: item.grnDetail_excessShortageQuantity,
        accValue: itemValue,
        rejectReason: item.grnDetail_RejectionReason,
        cst: item.grnDetail_CSTtax,
        pf: item.grnDetail_pfPercentage,
        disc: item.grnDetail_discountPercentage,
        value: totalValue.toFixed(2),
      };
    }),
  };

  // console.log(payload);

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.post("https://rfs2.infraconsoft.net.in/api/miscgrnReject_insert", payload);
    Swal.fire("Success", "Misc Grn Rejection added successfully", "success");
    setSelectedItems([]);
    navigate("/inventory/miscgrnRejectionView");
  } catch (error) {
    console.error("Error submitting form:", error);
    Swal.fire("Error", "Submission failed. Please try again.", "error");
  }
};


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                              <h2 className="add-txt">Misc GRN Rejection - Add</h2>
                              <Link to='/inventory/miscgrnRejectionView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                              </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
          <div className="form-row">
              <div className="form-group">
                <label>GRN Number:</label>
                <input type="text" name="PoNumber" value={formData.PoNumber} readOnly />
              </div>
              <div className="form-group">
                <label>GRN Date :</label>
                <input type="date" name="endhrs" value={new Date().toISOString().split("T")[0]} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>P.O Number :</label>
                <input type="text" name="scode" value={fetchPo} />
              </div>
              <div className="form-group">
                <label>Old GRN No :</label>
                <input type="text" name="scode" value={oldGrn} />
              </div>
            </div>


            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="scode" value={subDetails.supplierMaster_code} />
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" name="sname" value={subDetails.supplierMaster_name}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>DC No :</label>
                <input type="text" name="dcNo" value={formData.dcNo}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>DC Date :</label>
                <input type="date" name="dcDate" value={formData.dcDate}  onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Invoice No :</label>
                <input type="text" name="invoiceNo" value={formData.invoiceNo}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>Invoice Date :</label>
                <input type="date" name="invoiceDate" value={formData.invoiceDate}  onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="address1"value={subDetails.supplierMaster_addressline1} />
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input type="text" name="address2" value={subDetails.supplierMaster_addressline2}/>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="city"value={subDetails.supplierMaster_city} />
              </div>
              <div className="form-group">
                <label>Pin Code :</label>
                <input type="text" name="pincode" value={subDetails.supplierMaster_pincode}/>
              </div>
            </div>


            <div className="flex_buttons">
              <button type="button" className="button button-add" onClick={() => setShowModal(true)}>
                Add Item
              </button>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    {/* <th>Part Number</th> */}
                    <th>UOM</th>
                    <th>Unit Price</th>
                    <th>P.O Order Qty</th>
                    <th>GRN Accept Qty</th>
                    <th>GRN Reject Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedItems.length > 0 ? (
                    selectedItems.map((item, index) => {
                      const itemValue = item.grnDetail_excessShortageQuantity * item.grnDetail_price;
                      const discountValue = itemValue * (item.grnDetail_discountPercentage / 100);
                      const pfValue = itemValue * (item.grnDetail_pfPercentage / 100);
                      const taxValue = itemValue * (item.grnDetail_CSTtax / 100);
                      const totalValue = itemValue + taxValue + pfValue - discountValue;

                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.grnDetail_itemcode}</td>
                          <td>{item.itemmaster_name}</td>
                          {/* <td>{item.itemMaster_drawingNumber}</td> */}
                          <td>{item.itemMaster_purchaseUom}</td>
                          <td>{item.grnDetail_price.toFixed(2)}</td>
                          <td>{item.grnDetail_poPendingQuantity}</td>
                          <td>{item.grnDetail_packedQuantity}</td>
                          <td>{item.grnDetail_excessShortageQuantity}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="10">No items added</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>
          </form>
        </div>
      </div>

      <MiscGrnRejectionModal showModal={showModal} closeModal={() => setShowModal(false)} branch={branch} onSelectItem={handleSelectItem} />
    </div>
  );
};

export default AddMiscGrnReject;
